module.exports = __webpack_public_path__ + "img/chem_logo4.67027a40.png";